import type { CoinBalance } from '@/types/coins'

export const MOCK_COIN_BALANCE: CoinBalance = { balance: 3 }
